import dayjs from "dayjs";
import { useState } from "react";
import { useEffect } from "react";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import Spinner from "../../../../assets/icons/Spinner";
import TrashIcon from "../../../../assets/icons/TrashIcon";

import Message from "../../../../i18n/Message";

import {
  deleteToolPlugin,
  loadToolPlugin,
} from "../store/toolPluginActionCreators";
import { toolPluginSelectors } from "../store/toolPluginReducer";

import ToolTitle from "./ToolTitle";

import "./ToolPluginDetailsPage.scss";
import ToolContent from "./ToolContent";
import ChevronLeftIcon from "../../../../assets/icons/ChevronLeftIcon";

import NewWorkspaceLayout from "../../layout/NewWorkspaceLayout";
import { linkToToolPlugins } from "../../../../routes";

const ToolPluginDetailsPage = () => {
  const { toolId, workspaceId } = useParams();

  const intl = useIntl();
  const nav = useNavigate();
  const dispatch = useDispatch();
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const toolPlugin = useSelector(toolPluginSelectors.getToolPlugin);

  useEffect(() => {
    if (!toolPlugin || toolPlugin?.uid !== toolId) {
      dispatch(loadToolPlugin(intl, workspaceId, toolId));
    }
  }, [toolPlugin, toolId, workspaceId, dispatch, intl]);

  const onDeleteConfirmed = () => {
    const onSuccess = () => {
      setShowDeleteConfirm(false);
      nav(linkToToolPlugins(workspaceId));
    };
    dispatch(
      deleteToolPlugin(intl, workspaceId, toolId, onSuccess, () =>
        setShowDeleteConfirm(false)
      )
    );
  };

  const item = !!toolPlugin && toolPlugin?.uid === toolId ? toolPlugin : null;

  return (
    <NewWorkspaceLayout contentPanelClassName="tool_details_main">
      {!item && (
        <div className="spinner_container">
          <Spinner />
        </div>
      )}
      {item && (
        <>
          <div className="title_row">
            <div className="title_column">
              <div className="breadcrumbs">
                <div onClick={() => nav(linkToToolPlugins(workspaceId))}>
                  <ChevronLeftIcon
                    size={16}
                    strokeWidth="2"
                    color="rgb(103, 116, 142)"
                  />
                  <Message id="back_to_tools" />
                </div>
              </div>
              <div className="title_block">
                <div className="title_left">
                  <ToolTitle toolPlugin={item} />
                  <div className="metadata_row">
                    <div className="meta_name">
                      <Message id="created_on" />
                    </div>
                    <div className="meta_value">
                      {dayjs(item.dateCreated).format("DD MMM")}
                    </div>
                  </div>
                </div>
                <div className="title_actions">
                  <div className="confirm_container">
                    {showDeleteConfirm && (
                      <>
                        <div
                          className="cover"
                          onClick={() => setShowDeleteConfirm(false)}
                        ></div>
                        <div className="confirm_panel">
                          <button
                            className="btn bg-gradient-primary btn-sm"
                            onClick={onDeleteConfirmed}
                          >
                            <Message id="confirm_delete" />
                          </button>
                        </div>
                      </>
                    )}
                  </div>
                  <button
                    className="btn no-btn tile-action"
                    onClick={() => setShowDeleteConfirm(!showDeleteConfirm)}
                  >
                    <TrashIcon size="16" color="#344767" />
                    <Message id="delete" />
                  </button>
                </div>
              </div>
            </div>
          </div>
          <ToolContent tool={toolPlugin} />
        </>
      )}
    </NewWorkspaceLayout>
  );
};

export default ToolPluginDetailsPage;
